import styled from 'styled-components';

const ExplanationContainer = styled.div`
  background-color: var(--color-info-bg, #e7f3ff);
  border: 1px solid var(--color-info-border, #b8daff);
  border-radius: 6px;
  padding: 12px;
  margin-top: 10px;
  margin-bottom: 16px;
  font-size: 0.9rem;
  color: var(--color-info-text, #004085);
`;

const getDifficultySettings = (difficulty) => {
  const settings = {
    easy: { showFirstLetter: true, letterOnIncorrect: true, showWordLength: true, multiplier: 0.75 },
    normal: { showFirstLetter: true, letterOnIncorrect: true, showWordLength: false, multiplier: 1.0 },
    hard: { showFirstLetter: true, letterOnIncorrect: false, showWordLength: false, multiplier: 1.5 },
    impossible: { showFirstLetter: false, letterOnIncorrect: false, showWordLength: false, multiplier: 2.0 }
  };
  return settings[difficulty];
};

const DifficultyExplanation = ({ 
  difficulty 
}) => {

  const { showFirstLetter, letterOnIncorrect, showWordLength, multiplier } = getDifficultySettings(difficulty);

  const features = [];

  // score multiplier
  features.push(`• Score Multiplier: ${multiplier}x`);
  
  // show word length
  if (showWordLength) {
    features.push("• Shows word length");
  } else {
    features.push("• Word length hidden");
  }
  
  // show first letter
  if (showFirstLetter) {
    features.push("• Shows first letter of each word");
  } else {
    features.push("• No first letter hints");
  }
  
  // letter on incorrect
  if (letterOnIncorrect) {
    features.push("• Letter revealed on incorrect guess");
  } else {
    features.push("• No letter revealed on incorrect guess");
  }

  return (
    <ExplanationContainer>
      <strong>{difficulty.toUpperCase()}</strong>
      <br />
      {features.map((feature, index) => (
        <div key={index}>{feature}</div>
      ))}
    </ExplanationContainer>
  );
};

export default DifficultyExplanation;